module.exports = __webpack_public_path__ + "src/assets/games/42/81.jpg";